import { put } from "../../common/api/apiShared";
import { useDotLegalMutation, useDotLegalQueryClient, useDotLegalQueryWithKey } from "../../common/hooks/dotLegalReactQuery";
import { AiChatConversationListItem } from "../AiChat.types";

export const aiChatConversationsQueryKey = "ai-chat-conversations";

export function useAiChatConversationsQuery() {
    return useDotLegalQueryWithKey<AiChatConversationListItem[]>(aiChatConversationsQueryKey, "/ai-chat/conversations", {
        refetchInterval: (query) => {
            const data = query.state.data as AiChatConversationListItem[] | undefined;
            const anyProcessing = data?.some((c) => c.hasProcessingAttachments) ?? false;
            return anyProcessing ? 2000 : false;
        },
    });
}

export function useRenameAiChatConversationMutation() {
    const queryClient = useDotLegalQueryClient();
    return useDotLegalMutation<unknown, { id: string; title: string }>(({ id, title }) => put(`/ai-chat/conversations/${id}/rename`, { title }), {
        onSuccess: () => {
            queryClient.refetchQueries(aiChatConversationsQueryKey);
        },
    });
}
